import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AppLanguage } from '@app/shared/data-structure/language.interface';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent {
  @Input() appLanguage: string;
  @Input() languages: AppLanguage[];
  @Output() changeLanguage: EventEmitter<string> = new EventEmitter<string>();
}
